module.exports = __webpack_public_path__ + "static/media/032-magnet.844bc024.svg";